import styleKey from './styleKey'
const defaultStyle = new Map(
  [
    [styleKey.hide,{display: "none"}]
    ,[styleKey.toastPrimary,"toast toast-primary"]
    ,[styleKey.toastSuccess,"toast toast-success"]
    ,[styleKey.toastWarning,"toast toast-warning"]
    ,[styleKey.toastError,"toast toast-error"]
    ,[styleKey.inputButtonPrimary,"btn btn-primary"]
    ,[styleKey.inputButtonSuccess,"btn btn-success"]
    ,[styleKey.inputButtonWarning,"btn btn-warning"]
    ,[styleKey.inputButtonError,"btn btn-error"]
  ]
)
export default defaultStyle



// WEBPACK FOOTER //
// ./src/cnConst/defaultStyle.js